import React, { useMemo } from 'react'
import classNames from 'classnames'
import styles from './index.less'
import { Button, Tooltip } from 'antd'
import RedoOutlined from '@ant-design/icons/RedoOutlined'
import Action from '@/components/Action'
import Context, { ContextValueType } from '../../ConfigProvider/context'
import connectProvider from 'gyl-common/hocs/connectProvider'
import DownOutlined from '@ant-design/icons/DownOutlined'
import UpOutlined from '@ant-design/icons/UpOutlined'

const ActionButton = Action(Button)

/* 大于等于四行的世行，展示展开收起 */
export const showCollapseBtnRowIndex = 3

export const CollapseButton = ({ primaryColor, collapsed, toggleCollapsed }) => {
    return <Button
                type="link"
                className={classNames(styles.collapsed, styles.height28, {
                    [styles.primaryColor]: primaryColor
                })}
                onClick={toggleCollapsed as any}
            >
                {collapsed ? (
                    <>
                        展开&nbsp;
                        <DownOutlined />
                    </>
                ) : (
                    <>
                        收起&nbsp;
                        <UpOutlined />
                    </>
                )}
            </Button>
}

const SearchArea: React.FC<ContextValueType> = props => {
    const {
        style,
        handelSearch,
        contentBeforeCollapsedBtn,
        defaultIsShowCollapsedBtn,
        reset,
        handleReset,
        form,
        renderExtraOperate,
        hideRest,
        collapsed,
        toggleCollapsed,
        maxRowIndex,
        onRefresh,
        searchActionProps,
        resetActionProps
    } = props

    const isShowCollapsedBtn = useMemo<boolean>(() => {
        return defaultIsShowCollapsedBtn ?? maxRowIndex >= showCollapseBtnRowIndex
    }, [maxRowIndex, defaultIsShowCollapsedBtn])

    const renderContent =
        typeof contentBeforeCollapsedBtn === 'function' ? contentBeforeCollapsedBtn() : contentBeforeCollapsedBtn

    return (
        <div className={styles.operation} style={style}>
            <div className={styles.operationLeft}>{renderContent}</div>
            {isShowCollapsedBtn ? (
                <CollapseButton collapsed={collapsed} toggleCollapsed={toggleCollapsed} />
            ) : null}
            {onRefresh ? (
                <ActionButton
                    className={styles.height28}
                    type="link"
                    icon={<RedoOutlined />}
                    onClick={onRefresh as any}
                >
                    刷新列表
                </ActionButton>
            ) : null}
            <Tooltip title={searchActionProps?.tooltipMessage ?? undefined}>
                <Button
                    className={styles.height28}
                    type="primary"
                    onClick={handelSearch as any}
                    {...(searchActionProps || {})}
                >
                    搜索
                </Button>
            </Tooltip>
            {!hideRest && (
                <>
                    <div className={styles.placeholder} />
                    <Tooltip title={resetActionProps?.tooltipMessage ?? undefined}>
                        <Button
                            className={styles.height28}
                            onClick={() => {
                                reset ? reset(form) : handleReset()
                            }}
                            {...(resetActionProps || {})}
                        >
                            重置
                        </Button>
                    </Tooltip>
                </>
            )}
            {renderExtraOperate?.({
                className: styles.height28
            })}
        </div>
    )
}

const mapStateToProps = (context: ContextValueType) => {
    return {
        handelSearch: context?.handelSearch,
        onRefresh: context?.onRefresh,
        contentBeforeCollapsedBtn: context?.contentBeforeCollapsedBtn,
        reset: context?.reset,
        form: context?.form,
        handleReset: context?.handleReset,
        renderExtraOperate: context?.renderExtraOperate,
        hideRest: context?.hideRest,
        collapsed: context?.collapsed,
        toggleCollapsed: context?.toggleCollapsed,
        rowIndex: context?.rowIndex,
        maxRowIndex: context?.maxRowIndex,
        defaultIsShowCollapsedBtn: context?.defaultIsShowCollapsedBtn,
        quickSearchEnable: context?.quickSearchEnable,
        searchActionProps: context?.searchActionProps,
        resetActionProps: context?.resetActionProps
    }
}

export default connectProvider(mapStateToProps)(SearchArea, Context)
